import { useSubordinatesQuery } from 'app/services/edpApiV1/viewer';
import ConsultationFormAdditionally from 'features/consultations/consultationFormAdditionally';
import { TSingleConsultationPreparedData } from 'shared/types/consultations.types';
import ConsultationFormUserMain from '../consultationFormUserMain';

const ConsultationUserForm = ({
  dataConsultations,
  consultationRefetch,
}: {
  dataConsultations: TSingleConsultationPreparedData[];
  consultationRefetch: () => void;
}) => {
  const { data: allSubordinates } = useSubordinatesQuery({ include: 'me' });

  return (
    <>
      {allSubordinates && (
        <ConsultationFormUserMain allSubordinates={allSubordinates} dataConsultations={dataConsultations} />
      )}
      {dataConsultations && (
        <ConsultationFormAdditionally dataConsultations={dataConsultations} consultationRefetch={consultationRefetch} />
      )}
    </>
  );
};

export default ConsultationUserForm;
